import { useWriteLog } from '@/lib/queries'
import { statusOf } from '@/lib/status'
import { parseSqliteUtc } from '@/lib/time'
import type { WriteLogRow } from '@/api/client'
import { DataTable, Disclosure, EmptyState, StatusPill, When, type Column } from '@/ui'

const columns: Column<WriteLogRow>[] = [
  {
    key: 'at',
    header: '시각',
    card: 'sub',
    cell: (r) => <When iso={parseSqliteUtc(r.at)} mode="absolute" className="whitespace-nowrap tabular-nums" />,
  },
  { key: 'action', header: '변경', card: 'title', cell: (r) => <StatusPill domain="writeAction" status={r.action} /> },
  { key: 'actor', header: '주체', card: 'line', cell: (r) => <StatusPill domain="writeActor" status={r.actor} /> },
  {
    key: 'campaign',
    header: '캠페인',
    card: 'line',
    cell: (r) => (
      <div className="min-w-0">
        <div className="max-w-56 truncate" title={r.campaign_name}>
          {r.campaign_name || '—'}
        </div>
        {r.ads_campaign_id && (
          <div className="text-meta text-muted-foreground">
            {statusOf('network', r.network ?? 'google').label} · <span className="font-mono">{r.ads_campaign_id}</span>
          </div>
        )}
      </div>
    ),
  },
  {
    key: 'detail',
    header: '내용',
    card: 'sub',
    cell: (r) => (
      <div className="min-w-0 max-w-96">
        <div className="break-words">{r.detail || '—'}</div>
        {r.error && <div className="mt-0.5 break-words font-mono text-meta text-status-failed">{r.error}</div>}
      </div>
    ),
  },
  { key: 'result', header: '결과', card: 'meta', cell: (r) => <StatusPill domain="writeResult" status={r.ok ? 'ok' : 'failed'} /> },
]

function LogTable() {
  const log = useWriteLog(50)
  return (
    <div className="-mx-4 -my-4">
      <DataTable
        label="변경 기록"
        columns={columns}
        rows={log.data}
        rowKey={(r) => r.id}
        loading={log.isLoading}
        error={log.error}
        onRetry={() => log.refetch()}
        empty={<EmptyState title="아직 기록이 없다" description="콘솔과 동기화가 광고 플랫폼에 쓴 변경이 여기 쌓인다." />}
      />
    </div>
  )
}

/** Every write to the ad platform, newest first — who pressed it (or that the
 *  sync did), and whether Google took it. Folded: it is read when something
 *  changed that nobody remembers changing. */
export function WriteLogSection() {
  return (
    <Disclosure title="변경 기록" hint="콘솔과 동기화가 광고 플랫폼에 쓴 변경 · 최근 50건">
      <LogTable />
    </Disclosure>
  )
}
